<template>
  <div class="change_changyong_wraper">
    <div class="sceneview_wraper">
      <public-control-title>
        <span slot="left">丨</span>
        <span slot="text">常用场景设置</span>
      </public-control-title>
    </div>

    <!-- ////显示区域 -->
    <div class="context_change_wraper gun_dong_tiao_yin_chang">
      <!-- <device-view
        class="context_change_scene_view_wraper"
        :deviceList="serveSceneList"
        viewType="configDevice"
      ></device-view>-->
      <scene-view
        class="context_change_scene_view_wraper"
        :sceneList="serveSceneList"
        viewType="configScene"
      ></scene-view>
    </div>

    <!-- //////按钮区域 -->
    <div
      class="public_config_que_ren_btn change_changyong_wraper_btn"
      @click="configReturnBtnHandle"
    >
      确定配置
    </div>
  </div>
</template>

<script>
// import CollectSceneTitle from 'components/content/controllist/sceneList/collect-scene-title'
// import CollectDeviceTitle from 'components/content/controllist/deviceList/collect-device-title'
// import SceneView from 'components/content/controllist/sceneList/scene-view'
// import viewTitle from "components/content/contro-view/view-title";
import SceneView from 'components/content/contro-view/scene-view/scene-view'
// import DeviceView from "components/content/contro-view/device-view/device-view";
import publicControlTitle from 'components/content/contro-view/publiccontroltitle'

export default {
  name: 'HomeChangeScene',
  components: {
    publicControlTitle,
    // viewTitle,
    SceneView
    // DeviceView
    // CollectSceneTitle,
    // CollectDeviceTitle,
    // SceneView
  },
  data() {
    return {
      serveSceneList: [
        ///服务器请求到的场景列表
      ]
    }
  },
  methods: {
    configReturnBtnHandle() {
      ////处理一下入参
      let tempSceneList = []
      let tempSceneList1 = []
      ////进一步裁剪数据 只保存场景iD  和序号
      for (let i = 0; i < this.serveSceneList.length; i++) {
        if (this.serveSceneList[i].followState === 1) {
          ////说明该场景是收藏状态
          let Scene = {}
          Scene.followOrder = this.serveSceneList[i].followOrder
          Scene.sceneId = this.serveSceneList[i].sceneId

          tempSceneList.push(Scene)
        }
      }
      // 按照序号排序  正序
      tempSceneList.sort(function(a, b) {
        return a.followOrder - b.followOrder
      })
      console.log(tempSceneList)
      ////进一步裁剪数据 只保存场景iD
      for (let i = 0; i < tempSceneList.length; i++) {
        tempSceneList1.push(tempSceneList[i].sceneId)
      }
      console.log(tempSceneList1)

      // 用户添加常用场景 接口
      this.$request({
        method: 'post',
        url: '/userScene/saveFollowStateScene',
        data: {
          token: this.$store.state.token,
          sceneList: tempSceneList1
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveSceneList = res.data.data; ////拿到服务器返回的数据结果
            this.$router.replace('home')
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },

  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
    console.log('HomeChangeScene被创建了')
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  activated() {
    console.log('HomeChangeScene被激活了')

    // 获取首页所有场景信息接口
    this.$request({
      method: 'post',
      url: '/home/findAllSceneByUserId',
      data: {
        token: this.$store.state.token,
        regionId: '',
        followState: ''
      }
    })
      .then(res => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message)
          ////说明信息填写错误,控制失败了，
          return
        } else {
          ////、控制成功了
          this.serveSceneList = res.data.data ////拿到服务器返回的数据结果
          console.log(this.serveSceneList)
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    console.log('HomeChangeScene被渲染成功了')
  },
  beforeDestroy() {
    ////组件销毁前调用
    console.log('HomeChangeScene被销毁前')
  },
  destroyed() {
    console.log('HomeChangeScene被销毁后')
  }
}
</script>

<style>
.change_changyong_wraper {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.context_change_wraper {
  height: 100%;
}
.change_changyong_wraper_btn {
  margin-top: 30px;

  margin-bottom: 150px;
}
.context_change_scene_view_wraper {
  margin-top: 0px;
  margin-bottom: 200px;
}
</style>
